import { PrimaryButton } from '@monthio/design-system'
import { Container } from '@monthio/react-components'
import React from 'react'
import { useTranslation } from 'react-i18next'

import type { ConsentRequestDto } from '../../Eskat.types'

import { eskatApiClient } from '../../../../api/eskatApiClient'
import { StyledRegularButtonWrapper } from '../../Eskat.styled'
import { MitIdTestUsersTable } from './MitIdTestUsersTable'

interface SetDemoEnvConsentProps {
	setConsent: (consent: ConsentRequestDto) => void
}

export const DemoEnvConsent = ({ setConsent }: SetDemoEnvConsentProps) => {
	const [usingDemo, setUsingDemo] = React.useState(false)
	const { t } = useTranslation()

	return (
		<Container>
			<h3>{t('demo-env-title')}</h3>
			<StyledRegularButtonWrapper>
				<PrimaryButton
					disabled={usingDemo}
					onClick={async () => {
						setConsent(await eskatApiClient.getConsent({ useDemo: true }))
						setUsingDemo(true)
					}}
				>
					{usingDemo ? t('using-demo-env') : t('set-demo-env')}
				</PrimaryButton>
			</StyledRegularButtonWrapper>
			<MitIdTestUsersTable />
		</Container>
	)
}
